import LetterAvatar from "@/components/Avatar/LetterAvatar"
import StatusBadge from "@/components/ui/badge"

export const columns = [
  {
    header: "Date",
    cell: ({ row }) => (
      <>
        <div className="text-xs">AD: {row.original.created_at}</div>
        <div className="text-xs">BS: {row.original.created_at_bs}</div>
      </>
    ),
  },
  {
    header: "Source",
    accessorKey: "source",
  },
  {
    header: "Product Name",
    cell: ({ row }) => (
      <>
        <div>{row.original.product?.name}</div>
        <div className="text-xs !font-normal text-gray-500">
          SKU: {row.original.product?.sku}
        </div>
      </>
    ),
  },

  {
    header: "Reason",
    cell: ({ row }) => row.original.reason ?? "-",
  },
  {
    header: "Previous Total Stock",
    accessorKey: "previous_total_stock",
  },
  {
    header: "Quantity",
    accessorKey: "quantity",
  },
  {
    header: "Total Stock",
    accessorKey: "total_stock",
  },
  {
    header: "Type",
    cell: ({ row }) => <StatusBadge name={row.original.type} />,
  },
]
